import { Fragment } from 'react';
import SectionStyleRenderer from 'layout-dnd-utils/grids/render/SectionStyleRenderer';
import ContainerStyleRenderer from 'layout-dnd-utils/grids/render/ContainerStyleRenderer';
import ModuleStyleRenderer from 'layout-dnd-utils/grids/render/ModuleStyleRenderer';
import { getBreakpointMediaQueries } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function GridLayoutStyleContainer({
  gridLayoutTrees = {}
}) {
  // TODO: Come back here to think through memoizing strategy
  const gridLayoutNodesByTreeId = Object.values(gridLayoutTrees).reduce((acc, gridLayout) => {
    const sectionsById = gridLayout.getAllSectionsById();
    const containersById = gridLayout.getAllContainersById();
    const modulesById = gridLayout.getAllModulesById();
    acc.push([gridLayout.getRootId(), {
      sections: Object.values(sectionsById),
      containers: Object.values(containersById),
      modules: Object.values(modulesById)
    }]);
    return acc;
  }, []);
  const breakpointMediaQueries = useSelector(getBreakpointMediaQueries);
  return gridLayoutNodesByTreeId.map(([treeId, gridLayoutNodes]) => /*#__PURE__*/_jsxs(Fragment, {
    children: [gridLayoutNodes.sections.map(section => /*#__PURE__*/_jsx(SectionStyleRenderer, {
      section: section,
      breakpointMediaQueries: breakpointMediaQueries
    }, `${treeId}-${section.getId()}`)), gridLayoutNodes.containers.map(container => /*#__PURE__*/_jsx(ContainerStyleRenderer, {
      container: container,
      breakpointMediaQueries: breakpointMediaQueries
    }, `${treeId}-${container.getId()}`)), gridLayoutNodes.modules.map(module => /*#__PURE__*/_jsx(ModuleStyleRenderer, {
      module: module,
      breakpointMediaQueries: breakpointMediaQueries
    }, `${treeId}-${module.getId()}`))]
  }, treeId));
}